import { themed } from '@indeed/ifl-css';

const TouchTarget = /*#__PURE__*/themed("span", process.env.NODE_ENV === "production" ? {
  target: "ey2nhmw0"
} : {
  target: "ey2nhmw0",
  label: "TouchTarget"
})({
  position: "relative",
  "::after": {
    content: "''",
    position: "absolute",
    top: "50%",
    left: "50%",
    blockSize: "100%",
    inlineSize: "100%",
    minInlineSize: "44px",
    minBlockSize: "44px",
    transform: "translate(-50%, -50%)",
    zIndex: -1
  }
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRvdWNoVGFyZ2V0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFMkIiLCJmaWxlIjoiVG91Y2hUYXJnZXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdGhlbWVkLCBTdHlsZVByb3BzIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuXG5leHBvcnQgY29uc3QgVG91Y2hUYXJnZXQgPSB0aGVtZWQuc3BhbjxTdHlsZVByb3BzPih7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIFwiOjphZnRlclwiOiB7XG4gICAgY29udGVudDogXCInJ1wiLFxuICAgIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gICAgdG9wOiBcIjUwJVwiLFxuICAgIGxlZnQ6IFwiNTAlXCIsXG4gICAgYmxvY2tTaXplOiBcIjEwMCVcIixcbiAgICBpbmxpbmVTaXplOiBcIjEwMCVcIixcbiAgICBtaW5JbmxpbmVTaXplOiBcIjQ0cHhcIixcbiAgICBtaW5CbG9ja1NpemU6IFwiNDRweFwiLFxuICAgIHRyYW5zZm9ybTogXCJ0cmFuc2xhdGUoLTUwJSwgLTUwJSlcIixcbiAgICB6SW5kZXg6IC0xXG4gIH1cbn0pO1xuXG5Ub3VjaFRhcmdldC5kaXNwbGF5TmFtZSA9IFwiVG91Y2hUYXJnZXRcIjtcbiJdfQ== */");
TouchTarget.displayName = "TouchTarget";

export { TouchTarget };
